import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext({
  language: 'tr',
  toggleLanguage: () => { },
  t: (key) => key
});

export const useLanguage = () => useContext(LanguageContext);

const translations = {
  tr: {
    nav: {
      home: 'Anasayfa',
      about: 'Hakkımızda',
      services: 'Çözümler',
      references: 'Referanslar',
      blog: 'Blog',
      careers: 'Kariyer',
      contact: 'İletişim',
      portal: 'Portal'
    },
    auth: {
      signIn: 'Giriş Yap',
      signUp: 'Kayıt Ol',
      signOut: 'Çıkış',
      welcome: 'Hoş Geldiniz',
      backToHome: 'Ana sayfaya dön'
    },
    common: {
      getQuote: 'Teklif Al',
      learnMore: 'Detaylı Bilgi',
      loading: 'Yükleniyor...',
      search: 'Ara'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Solutions',
      references: 'References',
      blog: 'Blog',
      careers: 'Careers',
      contact: 'Contact',
      portal: 'Portal'
    },
    auth: {
      signIn: 'Sign In',
      signUp: 'Sign Up',
      signOut: 'Sign Out',
      welcome: 'Welcome',
      backToHome: 'Back to home'
    },
    common: {
      getQuote: 'Get Quote',
      learnMore: 'Learn More',
      loading: 'Loading...',
      search: 'Search'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('tr');

  useEffect(() => {
    const saved = localStorage.getItem('language');
    if (saved && ['en', 'tr'].includes(saved)) {
      setLanguage(saved);
    }
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'tr' : 'en';
    setLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
